<template>
	<div id="nav-bar">
		<span v-for="(item, index) in routers" :key="index">
			<span v-if="index !== 0">/</span>{{item}}
		</span>
	</div>
</template>

<script>
	export default {
		name: "NavBar",
		data() {
			return {
				routers: []
			}
		},
		computed:{

		},
		watch:{

		},
		methods: {
			push(n){
				this.routers.push(n)
			},
			init(n){
				if(n){
					this.routers = n.split("/")
				}
				
			},
			pop(){
				this.routers.pop()
			}
		},
		mounted() {
			this.$root.$nav = this
		}
	}
</script>

<style scoped lang="less">
	#nav-bar {
		color: #999999;
		font-size: 18rem;
		font-weight: 400;
	}
</style>